module.exports = __webpack_public_path__ + "static/media/arrow.321b7851.svg";